import { LOCATION_CHANGE, routerReducer } from "react-router-redux";
import { getLocation, hasUrlChanged } from "./selectors";
import { CLEAR_PREVIOUS_LOCATION } from "./constants";

export default function enhancedRouterReducer(state = {}, action = {}) {
  const newState = routerReducer(state, action);

  if (action.type === LOCATION_CHANGE) {
    if (hasUrlChanged(state, newState)) {
      return {
        ...newState,
        previousLocation: getLocation({ routing: state })
      };
    }

    return {
      ...state,
      ...newState
    };
  } else if (action.type === CLEAR_PREVIOUS_LOCATION) {
    return {
      ...newState,
      previousLocation: undefined
    };
  }

  return newState;
}
